import { FEATURE_FLAGS, FeatureFlag, FeatureFlagsState } from './featureFlags';

const STORAGE_KEY = 'features';

function isFeatureFlag(key: string): key is FeatureFlag {
  return FEATURE_FLAGS.includes(key as FeatureFlag);
}

export function loadFeatureFlags(): FeatureFlagsState {
  if (typeof window === 'undefined') return {};

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    const parsed = JSON.parse(raw) as Record<string, unknown>;

    const cleaned: FeatureFlagsState = {};
    Object.entries(parsed).forEach(([key, value]) => {
      if (isFeatureFlag(key) && typeof value === 'boolean') {
        cleaned[key] = value;
      }
    });

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(cleaned));

    return cleaned;
  } catch {
    return {};
  }
}

export function saveFeatureFlags(state: FeatureFlagsState): void {
  if (typeof window === 'undefined') return;

  const enabledOnly: FeatureFlagsState = {};

  Object.entries(state).forEach(([key, value]) => {
    if (value) {
      enabledOnly[key as FeatureFlag] = true;
    }
  });

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(enabledOnly));
}
